import { Subscription } from 'rxjs';
export class SubscriptionsController {
    constructor(host, subscribe) {
        (this.host = host).addController(this);
        this.subscribe = subscribe;
    }
    hostConnected() {
        this.subscriptions = new Subscription();
        for (const subs of this.subscribe()) {
            this.subscriptions.add(subs);
        }
    }
    hostDisconnected() {
        this.subscriptions.unsubscribe();
    }
}
//# sourceMappingURL=SubscriptionsController.js.map